import React          from 'react';
import classnames     from 'classnames';
import Tooltip        from './Tooltip';
import Label          from './Label';
import RadioComponent from './RadioComponent';

const RadioDualComponent = (props) => {
  const { name, parameters, groupName, errorMessage } = props;
  const value = parameters[name];
  return (
    <div className={classnames('form-group', props.className)}>
      <Label label={props.label} required={props.required} klassName={props.labelClassName}> <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} /> </Label>
      {' '}
      <RadioComponent
        inputId={`${groupName}-${props.name}-${props.valueA}`}
        name={name}
        label={props.labelA}
        value={props.valueA}
        checked={value === props.valueA}
        onChange={props.onChange}
        groupName={groupName}
        inline />
      {' '}
      <RadioComponent
        inputId={`${groupName}-${props.name}-${props.valueB}`}
        name={name}
        label={props.labelB}
        value={props.valueB}
        checked={value === props.valueB}
        onChange={props.onChange}
        groupName={groupName}
        inline />
      {errorMessage}
      <div>{props.children}</div>
    </div>
  );
};

RadioDualComponent.defaultProps = {
  labelA: 'Yes',
  labelB: 'No',
  valueA: '1',
  valueB: '0',
};

export default RadioDualComponent;
